export enum PresetsAPIRoutes {
    GET_SUBSIDIARIES = "subsidiary:query",
    GET_PRESETS = "config:settings:progressives:presets",
    NEW_PRESET = "config:settings:progressives:presets:create",
    GET_PRESET = "config:settings:progressives:presets:get",
    EDIT_PRESET = "config:settings:progressives:presets:edit",
    GET_DENOMINATIONS = "config:lists:denominations:query",
    CERTIFIED_PRESET = "config:settings:progressives:presets:set:certified",
    GET_BUNDLES = "games:bundle:query",
    GET_GAMES = "games:games:query"
}
